import { useContext } from 'react';
import { TopbarContext } from './Topbar';

export const useTopbarContext = () => {
    const context = useContext(TopbarContext);

    if (!context) {
        throw new Error('useTopbarContext must be used within Topbar.');
    }

    return context;
};
